/**
 * Search Object: This object creates and manipulates the DOM for the search.
 */

search = function () {
	'use strict';

	var objSearch = {};
	//var objDom = dom();
	var searchResultsWidth = 400;

	var page = 1;

	objSearch.reset = function() {
		$('#curriculog-site-search-field').val('').focus();
		objSearch.resultsHide();
	};

	objSearch.searchForm = function(key){
		// call search when they hit enter
		if (parseInt(key, 10) === 13) {
			$('#curriculog-site-search-field').blur();
			objSearch.search();
		} else if(parseInt(key, 10) === 27) {
			$('#curriculog-toolbar #view-search').trigger('click');
			objSearch.reset();
		}
	};

	objSearch.searchNext = function(location){
		page = page + 1;

		objSearch.search(location);
	};

	objSearch.searchPrev = function(location){
		page = page - 1;

		if (page < 0){
			page = 1;
		}

		objSearch.search(location);
	};

	objSearch.search = function(location) {
		$('.curriculog-site-search-results').animate({width:searchResultsWidth}, { duration:550, step: function(){
			if ($('.curriculog-site-search-results').width() > $('#curriculog-site-search-field').width()){
				$('#curriculog-site-search-field').css('width', $('.curriculog-site-search-results').width());
			}
		}, complete: function(){
			$('#curriculog-site-search-field').css('width', $('.curriculog-site-search-results').width());
			//objSearch.resultsShow($('<div>Loading</div>'));

			objSearch.overlayAdd();

		}});

		var search = {
			keyword : $('#curriculog-site-search-field').val(),
			exact_match : $('#site-search-exact-match').is(':checked'),
			prefix_code : $('#site-search-prefix-code').is(':checked'),
			page : page
		};

		if (location !== undefined){
			search.location = location;
		}

		$.ajax({
			url: '/search.ajax',
			type: 'get',
			data: search,
			beforeSend: function() {
				$('.curriculog-site-search-results').mask('Loading');
			},
			success: function(result){
				$('.curriculog-site-search-results').unmask();
				if (result) {
					objSearch.resultsShow(result, location);
				} else {
					$('#growls').notify('create', 'warning-template', {
						text: 'Not able to search. please try again.'
					});
				}
			}
		});
	};

	objSearch.resultsShow = function(searchResults, location) {
		if (searchResults !== undefined){
			if (location !== undefined){
				$('#result-' + location)
					.replaceWith(searchResults)
					.on('click', 'a.active', function(){
						$('.curriculog-site-search-results').mask('Loading');
					});

			} else {
				$('.curriculog-site-search-results')
					.html(searchResults)
					.on('click', 'a.active', function(){
						$('.curriculog-site-search-results').mask('Loading');
					});
			}
		}

		$('.curriculog-site-search-results').slideDown().addClass('active');
	};

	objSearch.resultsHide = function() {
		$('.curriculog-site-search-results').slideUp().removeClass('active');
		if ($('.curriculog-site-search-results').css('display') === 'block'){
			$('.curriculog-site-search-results').hide();
		}
	};

	objSearch.overlayAdd = function(key) {
		if ($('.search-overlay').size() < 1){
			$('body')
				.append(
					$('<div></div>')
						.addClass('ui-widget-overlay')
						.addClass('search-overlay')
						.css({ 'width' : $(window).width() + 'px',
							'height' : $(window).height() + 'px',
							'z-index': '30'})
					)
				.on('click', '.ui-widget-overlay.search-overlay', function(){
					$(this).remove();
					$('#curriculog-site-search').removeClass('active');
				});
		}
	};

	objSearch.overlayRemove = function(key) {
		$('.search-overlay').remove();
	};

	objSearch.overlayToggle = function(key) {
		if ($('.search-overlay').size() < 1){
			objSearch.overlayAdd();
		} else {
			objSearch.overlayRemove();
		}
	};

	return objSearch;

};
	
// event listener to make exact_match and prefix_code exclusive checkboxes
$(document).ready(function() {
	// Attach an event listener to 2nd one
	$('#site-search-prefix-code').on('change', function() {
		// If 2nd is checked, uncheck and disable 1st
		if ($(this).is(':checked')) {
			$('#site-search-exact-match').prop('checked', false).prop('disabled', true);
		}
		// If 2nd is unchecked, enable 1st
		else {
			$('#site-search-exact-match').prop('disabled', false);
		}
	});
});